export type PricingDAGResponse = {
  symbol: string;
  hasInput: boolean;
  tenor_index: number;
  tenor_input: boolean;
  dependencies: object;
  dependants: object;
};

export enum PricingType {
  Unspecified = 'unspecified',
  Trader = 'trader',
  Derived = 'derived',
}
